import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { BasicError, Error403 } from '../../models/error/error';
import { Activity } from '../../models/activity';
import { Thread } from '../../models/thread';
import { UserStatisticsService } from '../../services/user-statistics.service';
import { MessageService } from '../../services/message.service';
import { NaviService } from '../../services/navi.service';
import { inspect } from 'util';
import { PatientQuestionnaireService } from '../../services/patient-questionnaire.service';
import { Alarm } from '../../models/alarm';
declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  public myArr: Activity[] = [];
  public noElems = true;
  public infoText: String = 'Keine Aktivitäten vorhanden!';

  public totalAnswersheets = 0;
  public totalAnswersheetsFromToday = 0;
  public lastCollectedAt = null;
  public allMsg = 0;
  public allUnreadMsg = 0;
  public unreadMsg: Array<Thread> = [];
  public answers = [];
  public feedbacks: Array<Alarm> = [];


  constructor(private authenticationService: AuthenticationService, private userStatistic: UserStatisticsService,
    private messagerService: MessageService, private naviService: NaviService, private feedback: PatientQuestionnaireService) {
  }

  ngOnInit() {
    this.userStatistic.getMyActivities().subscribe(data => {
      this.myArr = data;
      if (this.myArr.length > 0) {
        this.noElems = false;
      }
    });

    this.userStatistic.getMyTotalAnswersheets().subscribe(data => {
      this.totalAnswersheets = data;
    });

    this.userStatistic.getMyAnswersheetsFromToday().subscribe(data => {
      this.totalAnswersheetsFromToday = data;
    });

    this.userStatistic.getCollectedAtFromToday().subscribe(data => {
      this.lastCollectedAt = data;
    });

    this.userStatistic.getAnswersheetsFiltered(false, null, null, null, 1).subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occurd');
        return;
      }
      this.answers = data;
      if (this.answers.length > 0) {
        const answersheetId = this.answers[0].getId();
        this.feedback.evaluateAnswersheet(answersheetId).subscribe(dd => {
          if (dd instanceof BasicError) {
            console.log('Error in evaluation of an answersheet');
          } else {
            this.feedbacks = dd;
          }
        });
      }
    });

    this.messagerService.getAllMessages().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Error occurd');
        return;
      }
      for (const thread of data) {
        if (thread instanceof Thread) {
          this.allMsg = this.allMsg + thread.getAmountMessages().valueOf();
          if (thread.getAmountUnreadMessages().valueOf() > 0) {
            this.allUnreadMsg = this.allUnreadMsg + thread.getAmountUnreadMessages().valueOf();
            this.unreadMsg.push(thread);
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    $(document).ready(function () {

    });
  }

  /**
   * This function replace the name Placeholder
   * @param a:Activity
   */
  public replaceName(a: Activity) {
    if (a.getName() === undefined || a.getName() === null || a.getName() === '') {
      return a.getText();
    }
    return a.getText().replace('{{name}}', a.getName().toString());
  }

  /**
   * This function returns the Date form the last submitted answersheet
   * @param t
   */
  public lastSubmittedTime(t: Number) {
    if (t === undefined || t === null) {
      return 0;
    }
    const lastDate = new Date(t.valueOf() * 1000);
    lastDate.setDate(lastDate.getDate());
    let date;
    date = (lastDate.getDate() > 9) ? lastDate.getDate() + '.' : '0' + lastDate.getDate() + '.';
    date = ((lastDate.getMonth() + 1) > 9) ? date + (lastDate.getMonth() + 1) : date + '0' + (lastDate.getMonth() + 1);
    date = date + '.';
    date = date + lastDate.getFullYear();
    return date;
  }

  public timerAfterSubmitted(t: Number) {
    if (t === undefined || t === null) {
      return 0;
    }
    const last = new Date(t.valueOf()  * 1000);
    const formatted = ('0' + last.getHours()).slice(-2) + ':' + ('0' + last.getMinutes()).slice(-2) + (' Uhr');
    return formatted;
  }

  public navigateToThread(t: Thread) {
    const url = 'messages/' + t.getId().toString();
    this.naviService.navigateToUrl(url, 'messages');
  }

  public navigateToStatistics() {
    const url = 'mygroups/1/statistics';
    this.naviService.navigateToUrl(url, 'mygroups');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/dashboard/dashboard.component.ts